import type { RectangleData } from '../../interfaces/rectangle-data.interface';
import type { NormalizerContext } from './codec-contract';

interface RotationSource {
  readonly rotation?: number;
  readonly naturalAligns: { readonly container: RectangleData };
}

/**
 * OLD splits rotation across `drawable.rotation` + `naturalAligns.container.angle`; NEW carries it as
 * one required `box.rotation`. The sum round-trips exactly, but the two-number split isn't
 * independently recoverable afterwards — `container.angle` is stably 0 from the next decode on.
 */
export function mergeRotation(drawable: RotationSource, ctx: NormalizerContext): number {
  const base = drawable.rotation ?? 0;
  const containerAngle = drawable.naturalAligns.container.angle ?? 0;
  if (containerAngle === 0) return base;
  ctx.warn('naturalAligns.container.angle folded into box.rotation, split not independently recoverable afterwards');
  return base + containerAngle;
}
